import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {ReportAccountComponentModel} from '../../../api/entity/reportAccountComponent.model';

@Injectable()
export class ReportAccountComponentRepository extends AbstractRepositoryV2<ReportAccountComponentModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ReportAccountComponent', serviceElementsFactory, injector);
    }
}
